exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".challenge-list-wrap{padding:20px}.image-box{width:100px}.image-box .story-imgs{width:100%;border-radius:6px}.avatar-box{width:60px}.avatar-box .avatar-imgs{width:100%;border-radius:6px}.search-box{padding:10px 0 20px}.search-box .search-tool .edit-box input::placeholder{color:#999}.dropdown-com{width:128px}.table-cell{vertical-align:middle}.table-row .btn-cell{text-align:center}.table-row .btn-cell .btn-item{display:inline-block;cursor:pointer}.table-row .btn-cell .btn-item.guan{margin-left:20px}.table-row .btn-cell .btn-item .btn-imgs{display:block;width:40px}.table-row .btn-cell .btn-item .xing-imgs{margin-bottom:6px}.table-row .btn-cell .btn-item .guan-imgs{width:48px}.table-row .btn-cell .btn-item .info{font-size:14px;color:#d0d0d0}.table-row .btn-cell .btn-item .info.red{color:#c9302c}.table-row>.table-cell:last-child{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/challenge/challenge-list/challenge-list.scss
// module id = 502
// module chunks = 2